var comparison = new Vue({
    el:'#comparison',
    data(){
        return{
            select:[
                {flag:false,index:0},
                {flag:false,index:1},
                {flag:false,index:3}
            ],
            displayNum:3,
            allData:[
                {
                    name:'XLIM PRO 4',
                    position:'Flagship Anti-Burn Pod',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_PRO_4_59735eec-4360-44d9-bafa-f33ee0440bb6.avif?v=1791940855',
                    url:'/pages/xlim-pro-4',
                    color:'10',
                    power:'5-30W<br>Automatic Match<br>Wattage Adjustable',
                    airflow:'Auto Draw<br>Button Activation<br>Airflow Control<br>RDL & MTL',
                    battery:'1800mAh<br>5V/3A Type-C',
                    screen:'0.98" HD Color Screen<br>RGB Light<br>4 Themes 3 Vaping Effects',
                    cartridge:'0.4/0.6/0.8/1.2Ω<br>ABT 2ML & 3ML',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_ABT_Product_Comparison_3ML.svg?v=1791940733',
                    mesh:'Single mesh only'
                },
                {
                    name:'XLIM 4',
                    position:'Sleek & Smart Pod',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM-4_70009fbe-fdec-4f07-9aa9-1e1e64ae97ad.avif?v=1790651528',
                    url:'/pages/xlim-4',
                    color:'10',
                    power:'5-30W<br>Automatic Match<br>3-Level Power',
                    airflow:'Auto Draw<br>-<br>Airflow Control<br>RDL & MTL',
                    battery:'1600mAh<br>5V/2A Type-C',
                    screen:'-<br>RGB Light<br>2 Vaping Effects',
                    cartridge:'0.4/0.6/0.8/1.2Ω<br>Top Fill 2ML & 3ML',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Product_Comparison_3ML.svg?v=1757302609',
                    mesh:'Single mesh only'
                },
                {
                    name:'VPRIME 2',
                    position:'Performance Pod',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/20260909-105822.avif?v=1788922819',
                    url:'/pages/vprime-2',
                    color:'6',
                    power:'5-60W<br>Automatic Match<br>Wattage Adjustable',
                    airflow:'Auto Draw<br>Button Activation<br>Airflow Control<br>DTL & RDL & MTL',
                    battery:'3400mAh<br>5V/3A Type-C',
                    screen:'0.98" Color Screen<br>-<br>3 Themes 2 Vaping Effects',
                    cartridge:'0.4/0.6Ω<br>VPRIME Dual Mesh Cartridge 0.4Ω/0.6 6ml/2ml(TPD)',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/VPRIME.svg?v=1733126739',
                    mesh:'Dual mesh'
                },
                {
                    name:'NeXLIM 2',
                    position:'Long-Lasting Flagship',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/20260624-094406.avif?v=1782265488',
                    url:'/pages/nexlim-2',
                    color:'9',
                    power:'5-40W<br>Automatic Match<br>Wattage Adjustable',
                    airflow:'Auto Draw<br>-<br>Airflow Control<br>RDL & MTL',
                    battery:'2000mAh & Super Pulse System<br>5V/3A Type-C',
                    screen:'0.85" Color Screen<br>-<br>10 Themes 1 Vaping Effect',
                    cartridge:'0.6/0.8/1.2Ω<br>NeXLIM Cartridge',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NEXLIM.svg?v=1733126739',
                    mesh:'Dual mesh'
                },
                {
                    name:'NeXLIM 2 MINI',
                    position:'Premium Starter',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/AuroraBlue_c74cd4b3-5535-4ede-8a0e-39d9214ce812.avif?v=1782454090',
                    url:'/pages/nexlim-2-mini',
                    color:'9',
                    power:'5-30W<br>Automatic Match<br>-',
                    airflow:'Auto Draw<br>-<br>Airflow Control<br>RDL & MTL',
                    battery:'1500mAh<br>5V/2A Type-C',
                    screen:'-<br>RGB Light<br>-',
                    cartridge:'0.6/0.8/1.2Ω<br>NeXLIM Cartridge',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NEXLIM.svg?v=1733126739',
                    mesh:'Dual mesh'
                },
                {
                    name:'XLIM GO Lite',
                    position:'Starter Pod',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Blue_Ripple_785ecd76-8a92-4477-b6be-99a6f746d821.avif?v=1776046055',
                    url:'/pages/xlim-go-lite',
                    color:'8',
                    power:'5-30W<br>Automatic Match<br>-',
                    airflow:'Auto Draw<br>-<br>Airflow Control<br>MTL',
                    battery:'1000mAh<br>5V/1A Type-C',
                    screen:'-<br>RGB Light<br>-',
                    cartridge:'0.4/0.6/0.8/1.2Ω<br>Top Fill 2ML & 3ML',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Product_Comparison_3ML.svg?v=1757302609',
                    mesh:'Single mesh only'
                },
                {
                    name:'XLIM 3 ULTRA',
                    position:'Smart Flagship',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Ultra_Carbon.avif?v=1762830413',
                    url:'/pages/xlim-3-ultra',
                    color:'14',
                    power:'5-30W<br>Automatic Match<br>Wattage Adjustable',
                    airflow:'Auto Draw<br>Button Activation<br>Airflow Control<br>RDL & MTL',
                    battery:'1500mAh & Super Pulse System<br>5V/2A Type-C',
                    screen:'2.2" HD Full Touch Screen<br>-<br>3 Themes 3 Vaping Effects',
                    cartridge:'0.4/0.6/0.8/1.2Ω<br>V1/V2/Top Fill 2ML & 3ML',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Product_Comparison_3ML.svg?v=1757302609',
                    mesh:'Single mesh only'
                },
                {
                    name:'XLIM PRO 3',
                    position:'Flagship Pod',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Sky_Blue_032a088d-828b-41c5-bb66-195048a0d1a0.avif?v=1762830413',
                    url:'/pages/xlim-pro-3',
                    color:'15',
                    power:'5-30W<br>Automatic Match<br>Wattage Adjustable',
                    airflow:'Auto Draw<br>Button Activation<br>Airflow Control<br>RDL & MTL',
                    battery:'1500mAh & Pulse System<br>5V/2A Type-C',
                    screen:'1.05" HD Color Screen<br>RGB Light<br>3 Themes 2 Vaping Effects',
                    cartridge:'0.4/0.6/0.8/1.2Ω<br>V1/V2/Top Fill 2ML & 3ML',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Product_Comparison_3ML.svg?v=1757302609',
                    mesh:'Single mesh only'
                },
                {
                    name:'XLIM PRO 2 DNA Version',
                    position:'DNA Flagship',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Luminous_Forged_Carbon_Fiber.png?v=1748231167',
                    url:'/pages/xlim-pro-2-dna',
                    color:'5',
                    power:'5-30W<br>Automatic Match<br>Wattage Adjustable',
                    airflow:'Auto Draw<br>Button Activation<br>Airflow Control<br>RDL & MTL',
                    battery:'1300mAh<br>5V/2A Type-C (Support data transmission)',
                    screen:'0.56" Color Screen<br>RGB Light<br>-',
                    cartridge:'0.4/0.6/0.8/1.2Ω<br>Top Fill SS<br>V1/V2/Top Fill<br> (Do not support Anti-burn & Flavor Replay Functions)',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/4691a794ca36e72949c9bf5b9f498b7a_6a02ed4a-353c-4bcf-8039-0db7a4f02b5c.svg?v=1733126760',
                    mesh:'Single mesh only'
                },
                {
                    name:'XLIM PRO 2',
                    position:'Flagship Pod',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Amber_Orange_f4046f4b-23a3-4dfe-bc8b-73dc3b2c6331.png?v=1741574116',
                    url:'/pages/xlim-pro-2',
                    color:'17',
                    power:'5-30W<br>Automatic Match<br>Wattage Adjustable',
                    airflow:'Auto Draw<br>-<br>Airflow Control<br>RDL & MTL',
                    battery:'1300mAh<br>5V/2A Type-C',
                    screen:'0.56" Color Screen<br>RGB Light<br>2 Themes',
                    cartridge:'0.4/0.6/0.8/1.2Ω<br>V1/V2/Top Fill',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/4691a794ca36e72949c9bf5b9f498b7a_6a02ed4a-353c-4bcf-8039-0db7a4f02b5c.svg?v=1733126760',
                    mesh:'Single mesh only'
                },
                {
                    name:'XLIM SQ PRO 2',
                    position:'Compact Smart Pod',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Celadon_Marble_2.png?v=1746583283',
                    url:'/pages/xlim-sq-pro-2',
                    color:'10',
                    power:'5-30W<br>Automatic Match<br>Wattage Adjustable',
                    airflow:'Auto Draw<br>-<br>Airflow Control<br>RDL & MTL',
                    battery:'1600mAh<br>5V/2A Type-C',
                    screen:'1.09" HD Smart Touch Screen<br>-<br>4 Themes | 4 Vaping Effects | 4 Wallpapers',
                    cartridge:'0.4/0.6/0.8/1.2Ω<br>V1/V2/Top Fill',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/4691a794ca36e72949c9bf5b9f498b7a_6a02ed4a-353c-4bcf-8039-0db7a4f02b5c.svg?v=1733126760',
                    mesh:'Single mesh only'
                },
                {
                    name:'XLIM GO 2',
                    position:'Starter Pod',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Metal_Blue_c732605b-8c4a-46ed-9d34-6a59c7c047ef.avif?v=1757298059',
                    url:'/pages/xlim-go-2',
                    color:'14',
                    power:'5-30W<br>Automatic Match<br>-',
                    airflow:'Auto Draw<br>-<br>Airflow Control<br>RDL & MTL',
                    battery:'1500mAh<br>5V/2A Type-C',
                    screen:'-<br>LED Light<br>-',
                    cartridge:'0.4/0.6/0.8/1.2Ω<br>V1/V2/Top Fill 2ML & 3ML',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Product_Comparison_3ML.svg?v=1757302609',
                    mesh:'Single mesh only'
                },
                {
                    name:'NeXLIM',
                    position:'Long-Lasting Flagship',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Coral_Orange_cfdce3ef-2b47-463b-8725-094cd2e8796e.png?v=1733104263',
                    url:'/pages/nexlim',
                    color:'18',
                    power:'5-40W<br>Automatic Match<br>Wattage Adjustable',
                    airflow:'Auto Draw<br>-<br>Airflow Control<br>RDL & MTL',
                    battery:'1500mAh<br>5V/2A Type-C',
                    screen:'0.85" Color Screen<br>RGB Light<br>3 Themes',
                    cartridge:'0.6/0.8/1.2Ω<br>NeXLIM Cartridge',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NEXLIM.svg?v=1733126739',
                    mesh:'Single & dual mesh'
                },
                {
                    name:'NeXLIM GO',
                    position:'Long-Lasting Starter',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/20260910-142341.avif?v=1789021462',
                    url:'/pages/nexlim-go',
                    color:'8',
                    power:'5-40W<br>Automatic Match<br>-',
                    airflow:'Auto Draw<br>-<br>Airflow Control<br>RDL & MTL',
                    battery:'1800mAh<br>5V/2A Type-C',
                    screen:'-<br>LED Light<br>-',
                    cartridge:'0.6/0.8/1.2Ω<br>NeXLIM Cartridge',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NEXLIM.svg?v=1733126739',
                    mesh:'Dual mesh'
                },
                {
                    name:'ONEO PRO',
                    position:'40W RDL Pod',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/20260708-100841.avif?v=1783476601',
                    url:'/pages/oneo-pro',
                    color:'8',
                    power:'5-40W<br>Automatic Match<br>Wattage Adjustable',
                    airflow:'Auto Draw<br>Button Activation<br>Airflow Control<br>RDL & MTL',
                    battery:'2100mAh<br>5V/2A Type-C',
                    screen:'0.96" TFT Screen<br>RGB Light<br>3 Themes 1 Vaping Effects',
                    cartridge:'0.4/0.6/0.8Ω<br>ONEO PRO Cartridge 4ml/2ml(TPD)',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/3_1.svg?v=1783476391',
                    mesh:'Single mesh only'
                },
                {
                    name:'UNIONE',
                    position:'10 ML Mega Pod',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/UNIONE_001.avif?v=1778638650',
                    url:'/pages/unione',
                    color:'7',
                    power:'-<br>Automatic Match<br>-',
                    airflow:'Auto Draw<br>-<br>Airflow Control<br>MTL',
                    battery:'1100mAh<br>5V/1A Type-C',
                    screen:'0.96" Hidden Screen<br>-<br>-',
                    cartridge:'0.8Ω<br>Top Fill 10ML & 2+8 ML',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_UNIONE_Product_Comparison_10ML.svg?v=1778639506',
                    mesh:'Single mesh only'
                },
                {
                    name:'SLIMSTICK NANO',
                    position:'Prefilled Pen-style Pod',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/20260915-093255.avif?v=1789436009',
                    url:'/pages/slimstick-nano',
                    color:'7',
                    power:'-<br>Automatic Match<br>-',
                    airflow:'Auto Draw<br>-<br>-<br>MTL',
                    battery:'600mAh<br>5V/0.5A Type-C',
                    screen:'-<br>RGB Light<br>-',
                    cartridge:'-<br>SLIMSTICK Cartridge (pre-filled) 2ML',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/slimstick.png?v=1757302817',
                    mesh:'Single mesh only'
                },
                {
                    name:'SLIMSTICK X',
                    position:'Slim Open Pod',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Purple_c3a05410-2d29-46ba-81cb-64da0c3e7981.avif?v=1772511509',
                    url:'/pages/slimstick-x',
                    color:'6',
                    power:'-<br>Automatic Match<br>-',
                    airflow:'Auto Draw<br>-<br>-<br>MTL',
                    battery:'1400mAh<br>5V/1A Type-C',
                    screen:'-<br>LED Light<br>-',
                    cartridge:'1.0Ω<br>SLIMSTICK X Cartridge (refillable) 2ML',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/20260209-180706.png?v=1770631673',
                    mesh:'Single mesh only'
                },
                {
                    name:'SLIMSTICK',
                    position:'Prefilled Slim Pod',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/600ae5829eb14c505f7b52c97a538910_7abf0d52-d5ac-4a98-8b7a-23db125f65b8.avif?v=1762392008',
                    url:'/pages/slimstick',
                    color:'6',
                    power:'-<br>Automatic Match<br>-',
                    airflow:'Auto Draw<br>-<br>-<br>MTL',
                    battery:'1500mAh<br>5V/1A Type-C',
                    screen:'-<br>LED Light<br>-',
                    cartridge:'-<br>SLIMSTICK Cartridge (pre-filled) 2ML',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/slimstick.png?v=1757302817',
                    mesh:'Single mesh only'
                },
                {
                    name:'ARTIO 2',
                    position:'Tobacco Flavor Pod',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Night_Blue_aa37637e-e37d-4b97-84c2-c24719af6a0e.avif?v=1763949118',
                    url:'/pages/artio-2',
                    color:'8',
                    power:'-<br>Automatic Match<br>-',
                    airflow:'Auto Draw<br>-<br>-<br>MTL',
                    battery:'900mAh<br>5V/2A Type-C',
                    screen:'-<br>LED Light<br>-',
                    cartridge:'-<br>ARTIO 2 Cartridge (pre-filled) 2ML',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_ProdARTIO_2_2ML.png?v=1763951237',
                    mesh:'Single mesh only'
                },
                {
                    name:'VPRIME',
                    position:'Performance Pod',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Natural_Green.png?v=1728890824',
                    url:'/pages/vprime',
                    color:'8',
                    power:'5-60W<br>Automatic Match<br>Wattage Adjustable',
                    airflow:'Auto Draw<br>Button Activation<br>Airflow Control<br>DTL & RDL & MTL',
                    battery:'2600mAh<br>5V/2A Type-C',
                    screen:'0.96" Color Screen<br>RGB Light<br>3 Themes',
                    cartridge:'0.2/0.4/0.6/0.8Ω<br>VPRIME Cartridge',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/VPRIME.svg?v=1733126739',
                    mesh:'Single mesh only'
                },
                {
                    name:'ONEO',
                    position:'Performance Pod',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Silky_Brown_4b710c91-e814-43b9-83d6-18d204af9ec4.png?v=1716963633',
                    url:'/pages/oneo',
                    color:'10',
                    power:'5-40W<br>Automatic Match<br>-',
                    airflow:'Auto Draw<br>-<br>Airflow Control<br>RDL & MTL',
                    battery:'1600mAh<br>5V/2A Type-C',
                    screen:'0.42"<br>RGB Light<br>-',
                    cartridge:'0.4/0.6/0.8/1.2Ω<br>ONEO Cartridge',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ONEO.svg?v=1733126739',
                    mesh:'Single mesh only'
                },
                {
                    name:'XLIM SQ PRO',
                    position:'Compact Flagship',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_SQ_PRO_2cae5a60-8307-4a42-aaeb-42b37b7254b6.png',
                    url:'/pages/xlim_sq_pro',
                    color:'12',
                    power:'5-30W<br>Automatic Match<br>Wattage Adjustable',
                    airflow:'Auto Draw<br>Button Activation<br>Airflow Control<br>RDL & MTL',
                    battery:'1200mAh<br>5V/2A Type-C',
                    screen:'0.96" Color Screen<br>LED Light<br>3 Themes',
                    cartridge:'0.4/0.6/0.8/1.2Ω<br>V1/V2/Top Fill',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/4691a794ca36e72949c9bf5b9f498b7a_6a02ed4a-353c-4bcf-8039-0db7a4f02b5c.svg?v=1733126760',
                    mesh:'Single mesh only'
                },
                {
                    name:'XLIM PRO',
                    position:'Flagship Pod',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Pine_Green_d0c541bc-924b-46fd-858e-04e1641d8f42.png?v=1711071886',
                    url:'/pages/xlim_pro',
                    color:'20',
                    power:'5-30W<br>Automatic Match<br>Wattage Adjustable',
                    airflow:'Auto Draw<br>Button Activation<br>Airflow Control<br>RDL & MTL',
                    battery:'1000mAh<br>5V/2A Type-C',
                    screen:'0.42"<br>RGB Light<br>-',
                    cartridge:'0.4/0.6/0.8/1.2Ω<br>V1/V2/Top Fill',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/4691a794ca36e72949c9bf5b9f498b7a_6a02ed4a-353c-4bcf-8039-0db7a4f02b5c.svg?v=1733126760',
                    mesh:'Single mesh only'
                },
                {
                    name:'XLIM GO',
                    position:'Starter Pod',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Red_09f77448-e8b2-46fc-9bba-bd6063545706.png?v=1713749171',
                    url:'/pages/xlim-go',
                    color:'16',
                    power:'5-30W<br>Automatic Match<br>-',
                    airflow:'Auto Draw<br>-<br>Airflow Control<br>RDL & MTL',
                    battery:'1000mAh<br>5V/1A Type-C',
                    screen:'-<br>LED Light<br>-',
                    cartridge:'0.4/0.6/0.8/1.2Ω<br>V1/V2/Top Fill',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/4691a794ca36e72949c9bf5b9f498b7a_6a02ed4a-353c-4bcf-8039-0db7a4f02b5c.svg?v=1733126760',
                    mesh:'Single mesh only'
                },
                {
                    name:'XLIM CLASSIC EDITION',
                    position:'Classic Pod',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Gradient_Green_faee2649-71fb-4e2b-82cb-8e017919f992.png',
                    url:'/pages/xlim-classic',
                    color:'10',
                    power:'5-30W<br>Automatic Match<br>Wattage Adjustable',
                    airflow:'Auto Draw<br>Button Activation<br>Airflow Control<br>RDL & MTL',
                    battery:'1000mAh<br>5V/2A Type-C',
                    screen:'0.42"<br>LED Light<br>-',
                    cartridge:'0.4/0.6/0.8/1.2Ω<br>V1/V2/Top Fill',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/4691a794ca36e72949c9bf5b9f498b7a_6a02ed4a-353c-4bcf-8039-0db7a4f02b5c.svg?v=1733126760',
                    mesh:'Single mesh only'
                },
                {
                    name:'XLIM SE 2',
                    position:'Starter Pod',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Black-Blue.png?v=1699840673',
                    url:'/pages/xlim-se-2',
                    color:'6',
                    power:'5-30W<br>Automatic Match<br>Wattage Adjustable',
                    airflow:'Auto Draw<br>Button Activation<br>Airflow Control<br>RDL & MTL',
                    battery:'1000mAh<br>5V/1A Type-C',
                    screen:'-<br>LED Light<br>-',
                    cartridge:'0.4/0.6/0.8/1.2Ω<br>V1/V2/Top Fill',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/4691a794ca36e72949c9bf5b9f498b7a_6a02ed4a-353c-4bcf-8039-0db7a4f02b5c.svg?v=1733126760',
                    mesh:'Single mesh only'
                },
                {
                    name:'XLIM SE',
                    position:'Starter Pod',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Orange-CF.png?v=1698196038',
                    url:'/pages/xlimse',
                    color:'14',
                    power:'5-25W<br>Automatic Match<br>-',
                    airflow:'Auto Draw<br>-<br>Airflow Control<br>RDL & MTL',
                    battery:'900mAh<br>5V/1A Type-C',
                    screen:'-<br>LED Light<br>-',
                    cartridge:'0.6/0.8/1.2Ω<br>V1/V2/Top Fill',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/4691a794ca36e72949c9bf5b9f498b7a_6a02ed4a-353c-4bcf-8039-0db7a4f02b5c.svg?v=1733126760',
                    mesh:'Single mesh only'
                },
                {
                    name:'XLIM POD',
                    position:'Classic Pod',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Shiny-Silver-Black_927af059-2437-4063-86b0-083403e8be48.png?v=1699440074',
                    url:'/pages/xlim-new-color',
                    color:'18',
                    power:'5-25W<br>Automatic Match<br>-',
                    airflow:'Auto Draw<br>Button Activation<br>Airflow Control<br>RDL & MTL',
                    battery:'900mAh<br>5V/1A Type-C',
                    screen:'0.42"<br>LED Light<br>-',
                    cartridge:'0.6/0.8/1.2Ω<br>V1/V2/Top Fill',
                    cartridgeImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/4691a794ca36e72949c9bf5b9f498b7a_6a02ed4a-353c-4bcf-8039-0db7a4f02b5c.svg?v=1733126760',
                    mesh:'Single mesh only'
                }
            ]
        }
    },
    methods:{
        changeNav(flag,index){
            this.select[flag].index = index
            this.select[flag].flag = false
        }
    }
})

$(document).on("click", function(e) {
    var container = $(".par_select");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        comparison.$data.select[0].flag = comparison.$data.select[1].flag = comparison.$data.select[2].flag = false
    }
});